import React from 'react';
import Main from './main-components/Main';
import Menubar from './main-components/Menubar';
import { useMediaQuery } from 'react-responsive';
import { Route } from 'react-router-dom';
import AiIntroduce from './ai-components/AiIntroduce';
import ChartMain from './chart-components/ChartMain';
import FinanceMain from './finance-components/FinanceMain';

const App: React.FC = () => {
  const isMobile = useMediaQuery({
    query: '(min-width:768px)',
  });
  return (
    <div>
      {isMobile ? (
        <Menubar title="TITLE" isMobile={!isMobile} />
      ) : (
        <Menubar title="TITLE" isMobile={!isMobile} />
      )}
      <Route path="/" exact={true} component={Main} />
      <Route path="/chart" component={ChartMain} />
      <Route path="/finance" component={FinanceMain} />
      <Route path="/ai" component={AiIntroduce} />
    </div>
  );
};

export default App;
